import React, { Component } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { Box, Button, DateRangePicker, Header, Multiselect, Pagination, SpaceBetween, Table, TextFilter } from "@cloudscape-design/components";

import { gamesEditModalStore } from "../stores/gamesEditModal";
import { gamesMetaTagsStore } from "../stores/gamesTagsModal";
import { gameStore } from "../stores/games";

class GamesMetaTagGameList extends Component {
	constructor(props) {
		super(props);
		this.loadTimeout;
		this.state = {
			games: [],
			filteredGames: [],
			isLoading: true,
			filters: {
				sorting: {
					column: "gameId",
					order: "asc",
				},
				search: "",
				page: 1,
				tags: [],
				limit: 10,
			},
		};
	}

	setFilter(options) {
		this.setState((prev) => ({
			...prev,
			filters: {
				...prev.filters,
				...options,
			},
		}));
	}

	handleClearFilter() {
		this.setState({
			filteredGames: this.state.games,
			isLoading: false,
			filters: {
				sorting: {
					column: "gameId",
					order: "asc",
				},
				search: "",
				page: 1,
				tags: [],
				limit: 10,
			},
		});
	}

	handleSearchGame(value) {
		this.setFilter({ search: value });
		clearTimeout(this.loadTimeout);

		this.loadTimeout = setTimeout(() => {
			this.onFilterGame();
		}, 500);
	}

	onFilterGame() {
		const { search, tags } = this.state.filters;
		this.setState((prev) => ({
			...prev,
			filters: {
				...prev.filters,
				page: 1,
			},
			filteredGames: this.state.games.filter((game) => {
				const isSearch = search ? game.name.toLowerCase().includes(search.toLowerCase()) : true;
				const isTags = tags.length > 0 ? game.tags.some((id) => tags.find((tag) => tag.value == id)) : true;
				return isSearch && isTags;
			}),
		}));
	}

	onFilteredMetaTagGame() {
		const games = [];

		this.setState({ isLoading: true });
		const isFiltered = (game) => {
			const isMetaTagInGame = game.metaTags.find((id) => id == this.props.metaTagId);
			return isMetaTagInGame;
		};

		for (let i = 0; i < this.props.games.length; i++) {
			if (isFiltered(this.props.games[i])) {
				games.push(this.props.games[i]);
			}
		}

		this.setState({ games, filteredGames: games, isLoading: false });
	}

	compare(a, b) {
		const aColumn = a[this.state.filters.sorting.column] || "";
		const bColumn = b[this.state.filters.sorting.column] || "";
		if (aColumn < bColumn) {
			return this.state.filters.sorting.direction === "desc" ? 1 : -1;
		}

		if (aColumn > bColumn) {
			return this.state.filters.sorting.direction === "desc" ? -1 : 1;
		}

		return 0;
	}

	componentDidMount() {
		this.onFilteredMetaTagGame();
	}

	render() {
		return (
			<Table
				columnDefinitions={[
					{
						id: "gameID",
						header: "Game Id",
						sortingField: "gameID",
						cell: (item) => (
							<Button
								onClick={() => {
									this.props.setGamesMetaTagsModal((prev) => ({ ...prev, show: 0 }));
									this.props.setGamesEditModal((prev) => ({ ...prev, editAllGames: false, biases: item.biases, show: true, loaded: false, providerID: item.providerID, id: item.gameID, editID: item.gameID, tagIds: item.tags.filter((tag) => Number(tag)) }));
								}}>
								{item.gameID}
							</Button>
						),
					},
					{
						id: "name",
						header: "Name",
						sortingField: "name",
						cell: (item) => item.name,
					},
					{
						id: "tags",
						header: "Tags",
						sortingField: "tags",
						cell: (item) => item.tags.join(", "),
					},
				]}
				items={this.state.filteredGames.sort((a, b) => this.compare(a, b)).slice((this.state.filters.page - 1) * this.state.filters.limit, this.state.filters.page * this.state.filters.limit)}
				loading={this.state.isLoading}
				sortingColumn={{ sortingField: this.state.filters.sorting.column }}
				sortingDescending={this.state.filters.sorting.direction === "desc"}
				onSortingChange={({ detail }) => {
					this.setFilter({
						sorting: { column: detail.sortingColumn.sortingField, direction: detail.isDescending ? "desc" : "asc" },
					});
				}}
				empty={
					<Box margin={{ vertical: "xs" }} textAlign="center" color="inherit">
						<SpaceBetween>
							<b>No Gamess</b>
							<Button variant="link" onClick={() => this.handleClearFilter()}>
								Clear filters
							</Button>
						</SpaceBetween>
					</Box>
				}
				filter={
					<SpaceBetween size="s">
						<TextFilter
							filteringPlaceholder="Find tag"
							filteringText={this.state.filters.search}
							onChange={({ detail }) => {
								this.handleSearchGame(detail.filteringText);
							}}
						/>
					</SpaceBetween>
				}
				header={
					<div>
						<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px", width: "100%", marginBottom: "10px" }}>
							<Header variant="h3">Tags Games</Header>
							{this.props.onClearMetaTag && (
								<Button variant="primary" wrapText={false} onClick={() => this.props.onClearMetaTag()} iconName="arrow-left">
									Back
								</Button>
							)}
						</div>
						<div style={{ display: "flex", alignItems: "center", gap: "10px", width: "100%", marginBottom: "10px" }}>
							<div style={{ minWidth: "300px" }}>
								<Multiselect
									inlineTokens
									hideTokens
									selectedOptions={this.state.filters.tags}
									onChange={({ detail }) => {
										this.setFilter({ tags: detail.selectedOptions });
										setTimeout(() => {
											this.onFilterGame();
										}, 200);
									}}
									placeholder="Tags"
									options={this.props.tags.map((tag) => ({ label: tag.name, value: tag.id }))}
								/>
							</div>
						</div>
					</div>
				}
				footer={
					<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px", width: "100%" }}>
						<Box variant="h4">Total:</Box>
						<Box>{this.state.filteredGames.length}</Box>
					</div>
				}
				pagination={
					<Pagination
						currentPageIndex={this.state.filters.page}
						onChange={({ detail }) => {
							this.setFilter({
								page: detail.currentPageIndex,
							});
						}}
						pagesCount={Math.ceil(this.state.filteredGames.length / this.state.filters.limit)}
						disabled={Math.ceil(this.state.filteredGames.length / this.state.filters.limit) === 1 || this.state.isLoading}
					/>
				}
			/>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const game = useRecoilValue(gameStore);
		const setGamesEditModal = useSetRecoilState(gamesEditModalStore);
		const setGamesMetaTagsModal = useSetRecoilState(gamesMetaTagsStore);
		return <Component games={game?.data || []} setGamesMetaTagsModal={setGamesMetaTagsModal} setGamesEditModal={setGamesEditModal} {...props} />;
	};
}

export default withRecoil(GamesMetaTagGameList);
